module.exports = __webpack_public_path__ + "img/empty.c2c25abd.png";